import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import IntakeModal from "@/components/IntakeModal";
import AppointmentModal from "@/components/AppointmentModal";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Bookkeeping from "@/pages/Bookkeeping";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";

function LegacyPostRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/tax-tips-blog/${slug}`} replace />;
}

function App() {
  const [intakeOpen, setIntakeOpen] = useState(false);
  const [appointmentOpen, setAppointmentOpen] = useState(false);

  const openIntake = () => setIntakeOpen(true);
  const openAppointment = () => setAppointmentOpen(true);
  const ctaProps = { onStartTax: openIntake, onBookAppointment: openAppointment };

  return (
    <div className="App min-h-screen bg-[#0B2545]">
      <BrowserRouter>
        <Header onStartTax={openIntake} onBookAppointment={openAppointment} />
        <main className="pb-20 sm:pb-0">
          <Routes>
            <Route path="/" element={<Home {...ctaProps} />} />
            <Route path="/our-services" element={<Services {...ctaProps} />} />
            <Route path="/marizema-bookkeeping-service" element={<Bookkeeping onBookAppointment={openAppointment} />} />
            <Route path="/about-us" element={<About onBookAppointment={openAppointment} />} />
            <Route path="/tax-tips-blog" element={<Blog />} />
            <Route path="/tax-tips-blog/:slug" element={<BlogPost onStartTax={openIntake} />} />
            <Route path="/contact" element={<Contact {...ctaProps} />} />
            {/* Old React paths -> permanent redirect (replace) to the preserved site paths */}
            <Route path="/services" element={<Navigate to="/our-services" replace />} />
            <Route path="/bookkeeping" element={<Navigate to="/marizema-bookkeeping-service" replace />} />
            <Route path="/about" element={<Navigate to="/about-us" replace />} />
            <Route path="/tax-tips" element={<Navigate to="/tax-tips-blog" replace />} />
            <Route path="/tax-tips/:slug" element={<LegacyPostRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <div data-testid="mobile-sticky-cta" className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-[#0B2545]/95 backdrop-blur-md border-t border-[#C9A227]/30 p-3 flex gap-2">
          <button data-testid="mobile-sticky-start-tax" onClick={openIntake}
            className="flex-1 text-sm font-bold px-4 py-2.5 rounded-full bg-[#C9A227] text-[#0B2545]">
            Start Tax Return
          </button>
          <button data-testid="mobile-sticky-book-appointment" onClick={openAppointment}
            className="flex-1 text-sm font-bold px-4 py-2.5 rounded-full border border-[#C9A227]/70 text-[#D4AF37]">
            Book Appointment
          </button>
        </div>
        <IntakeModal open={intakeOpen} onClose={() => setIntakeOpen(false)} />
        <AppointmentModal open={appointmentOpen} onClose={() => setAppointmentOpen(false)} />
      </BrowserRouter>
    </div>
  );
}

export default App;
